import axios from "axios";

const instance = axios.create({
    baseURL: "/api",
    withCredentials: true,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + process.env.MIX_INTRANET_API_TOKEN,
    },
});

// For live search
export const search = (name) => instance.get("/search", { params: { name } });

// For interactive map: Get pins by category
export const getPinsByCategory = (category) => instance.get(`/map/${category}`);

// Get municipalities
export const getMunicipalities = () => instance.get("/map/municipalities");

// Get vacations
export const getVacations = (params) => instance.get("/vacations", { params });

// Images
export const upload = (data) => instance.post("/database/upload", data);
export const getImages = (slug, id) =>
    instance.get(`/database/upload/${slug}/${id}`);
export const mainRemove = (slug, id) =>
    instance.post(`/database/upload/${slug}/${id}/main/remove`);
export const mainSet = (slug, id, imageId) =>
    instance.post(`/database/upload/${slug}/${id}/main/set/${imageId}`);
export const galleryImageRemove = (slug, id, imageId) =>
    instance.post(`/database/upload/${slug}/${id}/gallery/remove/${imageId}`);
export const gallery = (slug, id, data) =>
    instance.post(`/database/upload/${slug}/${id}/gallery`, data);
